/**
 * Single source of truth for the admin dashboard's layout breakpoint.
 *
 * Below this width the shell collapses to one column and the sidebar becomes an
 * off-canvas drawer; at or above it the tool keeps its two-column desktop layout.
 * 768px is the boundary already used by `page-header.module.css`, so adopting it
 * here does not shift any existing responsive behaviour.
 *
 * Tailwind's `md` is 48rem, which is this number - so anything written in
 * utilities (the shell, the sidebar, and the design-system's own DataTable and
 * PaginationFooter) collapses at this breakpoint without being told, via `md:`
 * and `max-md:`. This constant exists for the handful of decisions CSS cannot
 * make on its own: chiefly which ARIA semantics the nav column carries, since it
 * is a plain navigation column at desktop widths and a modal drawer below.
 *
 * CSS modules cannot read a JS constant, and a CSS custom property cannot be
 * used inside a `@media` prelude, so the stylesheets that remain repeat the
 * literal. Every one that does carries the comment:
 *
 *   Layout breakpoint - keep in sync with MOBILE_BREAKPOINT_PX in src/styles/breakpoints.ts
 *
 * Grep that string before changing the number here. The files are:
 *   src/styles/global.css
 *   src/components/common/filter-button.module.css
 *   src/components/common/form-field.module.css
 *   src/components/common/icon-button.module.css
 *   src/components/common/segmented-tabs.module.css
 *   src/components/common/featured-toggle.module.css
 *   src/components/common/view-link.module.css
 *   src/pages/advertisers/principal-search.module.css
 */
export const MOBILE_BREAKPOINT_PX = 768;

/**
 * Matches when the viewport is wide enough for the two-column desktop shell -
 * the same condition Tailwind's `md:` variant applies, so the JS decision and
 * the CSS one always agree.
 */
export const DESKTOP_MEDIA_QUERY = `(min-width: ${MOBILE_BREAKPOINT_PX}px)`;
